
import React, { Component } from "react";
import Iframe from "react-iframe";
import Sidebardata from "../../Publish/SidebarLeft";
import { baseUrl } from "../../../../../utils";
import CodeSection from "./CodeSection";
import LoadingScreen from "../../../../CommonComponents/LoadingScreen";
import { toggleAddFeedsSection_D, toggleManageSection_D, togglePlanSection_D } from "../../../../../actions/showDisplayModalAction";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";


const Preview = (props) => {
    const navigate = useNavigate();
    return <PW navigate={navigate} {...props} />
}
class PW extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingIframe: false
        }
    }

    componentDidMount() {

        const { wallData } = this.props;

        this.handleMessage = (event) => {
            if (event.data === '5') {
                this.props.upgradePlan();
            } else if (event.data === "addFeeds") {
                this.props.addFeed()
                this.props.navigate(`/wall/index/${wallData.wallId}`)
            } else if (event.data === "manageFeeds") {
                this.props.addFeed()
                this.props.navigate(`/wall/index/${wallData.wallId}`)
            }
        }
        window.addEventListener('message', this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    getIframe = (e) => {
        setTimeout(() => {
            this.setState({ loadingIframe: true })
        }, 1500);
    }

    render() {
        const { url, step, useCase, product, selectUseCaseType, useCaseData, selectProduct, getCode, widgetOptions, wallData } = this.props;
        const { loadingIframe } = this.state
        const index = useCase == 'projector' ? 0 : useCase == 'signage' ? 1 : 2;
        const json = Sidebardata()[index];


        return <div className="preview_box">
            <div className={`main_preview ${step == 2 ? 'preview-inner' : ''}`}>
                {(step > 1 && (product == 'display' && useCase) || (product == 'widget')) ? <div className="mb-4 border-bottom">
                    <ul className="preview-tabs header-tabs nav flex-wrap p-0 justify-content-start">
                        {product == 'display' ? useCase ? json.map((item, index) => item.content != 'otherSection' ? <li className={`nav-item d-flex me-2 mb-3`} key={`${item.icon}-${index}`} onClick={() => selectUseCaseType(item)}>
                            <button className={`nav-link d-flex align-items-center rounded py-0 bg-transparent w-100 justify-content-center ${(item.icon == useCaseData?.icon) ? 'active' : ''} ${(item.icon == 'easy-signage') ? 'px-2' : 'px-8'}`}>
                                <span className="nav-icon w-auto position-relative">
                                    <span className="tab-svg-icon">
                                        <img width={item.width} height={item.height} src={baseUrl(`display-logo/${item.icon}.svg`)} />
                                    </span>
                                </span>
                            </button>
                        </li> : null) : null :
                            widgetOptions.map((curr, index) => {
                                const { popupID, classActive } = curr;
                                let activeclass = classActive.split(" ");
                                return (
                                    <li className={`nav-item d-flex me-2 mb-3 ${(popupID == useCaseData?.icon) ? 'active' : ''}`} key={`${popupID}-${index}`} onClick={() => selectUseCaseType(curr)}>
                                        <a
                                            className={`nav-link d-flex align-items-center rounded py-0 px-8 bg-transparent ${activeclass[0]}`}
                                            data-bs-toggle="pill"
                                            href={`#${popupID}`}>
                                            <span className="nav-icon w-auto position-relative">
                                                <span className="tab-svg-icon">
                                                    <img src={baseUrl(`display-logo/${popupID}.svg`)} />
                                                </span>
                                            </span>
                                        </a>
                                    </li>
                                );
                            })}
                    </ul>
                </div> : null}
                {step < 3 ?
                    <>
                        <div className="device device-desktop pubsizeSection" style={{ display: loadingIframe ? 'block' : 'none' }}><Iframe src={url} onLoad={(e) => this.getIframe(e)}  ></Iframe></div>
                        <div style={{ display: loadingIframe ? 'none' : 'block' }}><LoadingScreen /></div>
                    </>
                    :
                    <CodeSection {...{ useCaseData, product, selectProduct, widgetOptions, useCase, wallData }} />
                }


                {step == 2 && product == "widget" ? <div className="preview-publish mt-3 text-end">
                    <button id="preview_btn" className="btn ms-3 btn btn-primary preview_btn" data-factors-click-bind="true" onClick={getCode}>Generate Code</button>
                </div> : null}
            </div>
        </div>
    }
}



const mapDispatchToProps = dispatch => {
    return {
        upgradePlan: () => dispatch(togglePlanSection_D(true)),
        manageFeed: () => dispatch(toggleManageSection_D(true)),
        addFeed: () => dispatch(toggleAddFeedsSection_D(true))
    }
}

export default connect(null, mapDispatchToProps)(Preview)

